// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileHeaderOnly_wrapper__+t14v","content":"MobileHeaderOnly_content__99cMb"};